import { render, staticRenderFns } from "./GenMenuForm.vue?vue&type=template&id=7132401a"
import script from "./GenMenuForm.vue?vue&type=script&lang=js"
export * from "./GenMenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7132401a')) {
      api.createRecord('7132401a', component.options)
    } else {
      api.reload('7132401a', component.options)
    }
    module.hot.accept("./GenMenuForm.vue?vue&type=template&id=7132401a", function () {
      api.rerender('7132401a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/GenMenuForm.vue"
export default component.exports